<template>
  <popup-headline
    :title="translations.title"
    :is-loading="isLoading"
    :is-close-state="isClose"
    @toggle-popup="togglePopup"
  />
  <div
    v-show="state.isPopupOpened"
    class="u-mt--s"
  >
    <div
      v-if="!state.isListening"
      class="c-hands-free-content u-font-size-large"
      v-html="translations.content"
    />
    <div
      v-if="state.isListening"
      class="c-hand-free-introduction-steps"
    >
      <div
        class="step"
        v-html="translations.steps[currentStep]"
      />
      <div class="introduction-buttons">
        <button
          class="c-button u-mt--s"
          :disabled="currentStep < 1"
          @click="goToPrevStep"
        >
          <Icon
            class="u-mr--xs"
            :icon="iconChevronLeft"
            :size="24"
          />
        </button>
        <button
          class="c-button u-mt--s"
          @click="goToNextStep"
        >
          <Icon
            class="u-mr--xs"
            :icon="iconChevronRight"
            :size="24"
          />
        </button>
      </div>
    </div>
    <button
      v-if="!state.isListening"
      class="c-button u-font-size-large u-mt--s"
      @click="beginListening"
    >
      {{ translations.buttonText }}
    </button>
  </div>
</template>

<script>

import { ref, computed } from 'vue'
import { state, togglePopupState, updateCurrentStage } from '@/composition/voiceState'
import Icon from '@/components/Icon.vue'
import iconChevronLeft from '@/assets/img/icons/chevron--left.svg'
import iconChevronRight from '@/assets/img/icons/chevron--right.svg'
import PopupHeadline from '@/components/recipe/handFreeCookingStages/PopupHeadline.vue'

export default {
  components: {
    PopupHeadline,
    Icon
  },
  props: {
    translations: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isCloseState: {
      type: Boolean,
      default: false
    }
  },
  emits: ['togglePopup', 'beginListening'],
  setup(_, { emit }) {
    const currentStep = ref(0)
    const isClose = computed(() => (_.isCloseState && !state.isListening))
    const togglePopup = () => {
      emit('togglePopup')
    }
    const beginListening = () => {
      emit('beginListening')
    }

    const goToPrevStep = () => {
      if (currentStep.value > 0) {
        currentStep.value -= 1
      }
    }

    const goToNextStep = () => {
      currentStep.value += 1
      if (currentStep.value === _.translations.steps.length) {
        updateCurrentStage('listening')
        togglePopupState(false)
      }
    }

    return {
      togglePopup,
      beginListening,
      goToPrevStep,
      goToNextStep,
      isClose,
      currentStep,
      state,
      iconChevronLeft,
      iconChevronRight
    }
  }
}
</script>
